import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatcher2xvjdz9qh940 as Dispatcher } from './gql/GqlQuery.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_perform__v6ng8j($this, query, $completion) {
  var tmp = $this.o6q().x6q(query.y6q_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.t44();
}
function perform(query, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_perform__v6ng8j.bind(VOID, this, query), $completion);
}
var SdkGraphQueryDispatcherClass;
function SdkGraphQueryDispatcher() {
  if (SdkGraphQueryDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGraphQueryDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkGraphQueryDispatcherClass = $;
  }
  return SdkGraphQueryDispatcherClass;
}
//region block: exports
export {
  SdkGraphQueryDispatcher as SdkGraphQueryDispatcher2qog4v6gbj5of,
  perform as performs68l90ameoy1,
};
//endregion

//# sourceMappingURL=SdkGraphQueryDispatcher.mjs.map
